import React, { useContext } from "react";
import { ScreenContext } from "../../contexts/ScreenContext";

export const VIEWS = {
  home: "home",
  chatAddList: "addUser",
  chatMessList: "users",
};

export default function MobileNavigationsViews({
  homeView = null,
  addUserView = null,
  userView = null,
}) {
  const { inMobileView } = useContext(ScreenContext);

  const renderViews = (view) => {
    switch (view) {
      case VIEWS.home:
        return homeView;
      case VIEWS.chatAddList:
        return addUserView;
      case VIEWS.chatMessList:
        return userView;
      default:
        return homeView;
    }
  };
  return <>{renderViews(inMobileView)}</>;
}
